/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useAttachTwilioTrack } from '../hooks/useAttachTwilioTrack';
export var AudioTrack = function (_a) {
    var className = _a.className, track = _a.track;
    var ref = useAttachTwilioTrack(track);
    return jsx("div", { ref: ref, className: className });
};
//# sourceMappingURL=AudioTrack.js.map